import { Form, Formik } from 'formik';
import { InputField } from 'components/Formik/InputField';
import { css, cx } from '@linaria/core';
import { baseTheme, flex } from 'styles/utils';
import { Button } from 'components/ui_library/Button';
import { formatDollarsToCents } from 'utils/pricing';
import { useState } from 'react';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { PaymentMethod } from '../PaymentMethod';
import { AutoRechargeFormValues, RechargeModalProps } from './type';
import { rechargeValidationSchema } from './formSchemaValidation';
import { useCreditBalance } from '../hooks/useCreditBalance';
import { useEditCreditCard } from '../hooks/useEditCreditCard';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { sanitizeInputNumber } from './utils';
const customRecharge = 'custom-recharge-amount';
export const RechargeModal = ({
  onClose,
  onConfirm
}: RechargeModalProps) => {
  const {
    rechargeCreditBalance,
    isRechargingBalance
  } = useCreditBalance();
  const {
    updateCreditCardIfNeeded
  } = useEditCreditCard();
  const presetAmounts = [10, 25, 100, 500, customRecharge];
  const [selectedAmountOption, setSelectedAmountOption] = useState<string | number>();
  const handleRecharge = (values: Pick<AutoRechargeFormValues, 'rechargeAmount' | 'creditCard'>): void => {
    rechargeCreditBalance({
      amount: Number(values.rechargeAmount),
      description: 'Recharge Credit Balance'
    }, {
      onSuccess: () => {
        cogoToast.success('Amounts credited successfully');
        onConfirm?.(values);
      },
      onError: () => {
        cogoToast.error('Failed to add credits. Please try again.');
      }
    });
  };
  const handleFormSubmit = async (values: Pick<AutoRechargeFormValues, 'rechargeAmount' | 'creditCard'>) => {
    try {
      await updateCreditCardIfNeeded(values?.creditCard);
      handleRecharge({
        rechargeAmount: formatDollarsToCents(Number(values.rechargeAmount))?.toString(),
        creditCard: values.creditCard
      });
    } catch {
      cogoToast.error('Failed to update payment method. Please try again.');
    }
  };
  const handleInputChange = (fieldName: string, value: string, setFieldValue: (field: string, value: string) => void) => {
    const sanitizedValue = sanitizeInputNumber(value);
    setFieldValue(fieldName, sanitizedValue);
  };
  return <div className={container}>
      <ModalHeader onClose={onClose} title="Add credits" />
      <Formik initialValues={{
      rechargeAmount: '',
      creditCard: {
        value: '',
        name: '',
        content: <></>,
        metaData: ({} as CF.API.Users.Card)
      }
    }} onSubmit={handleFormSubmit} validationSchema={rechargeValidationSchema} enableReinitialize>
        {({
        isValid,
        values,
        setFieldValue
      }) => {
        const showCustomInput = selectedAmountOption === customRecharge;
        return <Form>
              <div className="payment-method">
                <>
                  <div className={cx(flex.init, flex.gap[1])}>
                    {presetAmounts.map(amount => {
                  const isSelected = selectedAmountOption === amount;
                  return <Button key={amount} variant="secondary" className={cx('amountsBtn', isSelected && 'active')} onClick={() => {
                    setSelectedAmountOption(amount);
                    if (amount === customRecharge) {
                      setFieldValue('rechargeAmount', '');
                    } else {
                      setFieldValue('rechargeAmount', amount.toString());
                    }
                  }}>
                          {amount === customRecharge ? 'Custom' : `$${amount}`}
                        </Button>;
                })}
                  </div>

                  {showCustomInput && <InputField name="rechargeAmount" label="Amount to add" type="text" id="recharge-amount" required LeftIcon={<span className="currency">$</span>} onChange={e => handleInputChange('rechargeAmount', e.target.value, setFieldValue)} />}

                  <PaymentMethod label="Select Payment Method" required selectedPaymentMethodId={values.creditCard?.value} onPaymentMethodChange={card => {
                setFieldValue('creditCard', card);
              }} />
                </>
              </div>

              <ModalFooter onClose={onClose} isConfirmDisable={!isValid || !values?.creditCard?.value} isLoading={isRechargingBalance} confirmText="Add credits" showPricingLink />
            </Form>;
      }}
      </Formik>
    </div>;
};
export const container = "odules__User__components__Settings__Billing__AutoRecharge__RechargeModal_tsx-container-c1j0sezd";

require("./RechargeModal.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RechargeModal.tsx");